export const isAuthenticated = () => {
  const user = localStorage.getItem('auth');
  if (!user) {
    return false;
  }
  return user;
};
